<template>
  <div class="row justify-content-center">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div style="height: 20px"></div>
          <div class="card">
            <div class="card-header card-header-primary">
              <h3 class="card-title">
                Modification des informations du livreur <b>{{ user.name }}</b>
              </h3>
            </div>
            <div class="card-body">
              <div>
                <b-alert
                  v-if="user.statusLivreur == '0'"
                  variant="danger"
                  show
                >
                  <p style="font-size: 1.3em">
                    Ce compte livreur est désactivé!!!
                  </p>
                </b-alert>
                <b-alert v-if="user.statusLivreur == '1'" variant="default"
                  show
                  style="background-color: #34b76e"
                >
                  <p style="font-size: 1.3em">
                    Ce compte livreur est activé!!!
                  </p>
                </b-alert>
              </div>

              <form @submit.prevent="onUpdateForm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" style="color: #34b76e; font-size: 1.2em; text-transform: capitalize;">
                        Nom du livreur
                      </label>
                      <input v-model="user.name" type="text" class="form-control" required style="border-radius: 10px 10px 10px 10px" disabled/>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" style="color: #34b76e; font-size: 1.2em; text-transform: capitalize;">
                        Contact du livreur
                      </label>
                      <input
                        v-model="user.number" type="text" class="form-control" required style="border-radius: 10px 10px 10px 10px" disabled
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" style="color: #34b76e; font-size: 1.2em; text-transform: capitalize;">
                        Status du livreur
                      </label>
                      <select class="form-control" v-model="user.statusLivreur" required style="border-radius: 10px 10px 10px 10px">
                        <option value="0">Desactivé ce livreur</option>
                        <option value="1">Activé ce livreur</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        class="bmd-label-floating"
                        style="color: #34b76e; font-size: 1.2em; text-transform: capitalize;">
                        Adresse email du livreur
                      </label>
                      <input v-model="user.email" type="text" class="form-control" disabled/>
                    </div>
                  </div>
                </div>

                <button
                  class="btn btn-success pull-right"
                  style="background-color: #34b76e; color: white; border-radius: 10px 10px 10px 10px;">
                  Mettre à jour
                </button>
                <div class="clearfix"></div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div style="height: 109px"></div>
    </div>
  </div>
</template>

<script>
import { db } from "../../main";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      user: {},
    };
  },

  created() {
    let dbRef = db.ref("users").child(this.$route.params.id);
    dbRef
      .get()
      .then((childSnapshot) => {
        const childData = childSnapshot.val();
        this.user = childData;
      })
      .catch((error) => {
        console.log(dbRef);
      });
  },

  methods: {
    onUpdateForm(event) {
      let go = this;
      event.preventDefault();
      db.ref("users")
        .child(this.$route.params.id)
        .set(this.user)
        .then(() => {
          console.log("Mise à jour effectuée!");
          go.$router.push({ path: "/admin/livreur" });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Mise à jour éffectuée",
            showConfirmButton: true,
            timer: 4000,
            allowOutsideClick: false,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
